/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import queryString from 'query-string';
import type ServicedeskQueuesConfigType from '@jira/spa-apps__servicedesk-queues-config/src/index.tsx';
import type { SettingsContainerContentQuery } from '@jira/servicedesk__queues-config/src/__generated__/SettingsContainerContentQuery.graphql.ts';
import type { EntryPointProps } from 'react-relay';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import {
	type Match,
	type Route,
	type RouteContext,
	Redirect,
} from '@atlassian/react-resource-router';

/**
 * @deprecated remove when queues config routes migrate to the entry-point based pattern
 */
export const LazyServicedeskQueuesConfig: LazyComponent<
	({
		queries: { SettingsContainerContentQuery },
		extraProps,
	}: EntryPointProps<
		{
			SettingsContainerContentQuery: SettingsContainerContentQuery;
		},
		{},
		{},
		{
			query: {
				config?: string;
			};
			match: Match;
			route: Route;
		}
	>) => React.JSX.Element
> = lazyForPaint<typeof ServicedeskQueuesConfigType>(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-queues-config", jiraSpaEntry: "async-servicedesk-queues-config" */ '@jira/spa-apps__servicedesk-queues-config/src/index.tsx'
		),
);

/**
 * @deprecated remove when queues config routes migrate to the entry-point based pattern
 */
export const ServicedeskQueuesConfig = (props: RouteContext): React.JSX.Element => {
	const { query } = props;

	// If URL is from edit queue, then redirect to the new URL with config query param
	if (!query.config) {
		const { config, ...restQuery } = query;
		return (
			<Redirect
				to={{
					pathname: `${props.location.pathname}`,
					hash: '',
					search: queryString.stringify({
						...restQuery,
						config: 'queueConfig',
					}),
				}}
			/>
		);
	}

	return (
		<LazyPage
			Page={LazyServicedeskQueuesConfig}
			pageId={`spa-apps/servicedesk/queues/config/${query.config}`}
			shouldShowSpinner
		/>
	);
};
